import * as React from 'react';

import * as styles from './styles.css';

export interface IProfiItemProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
}

export const ProfiItem: React.FC<IProfiItemProps> = ({ icon, title, description }) => {
  return (
    <div className={styles['item']}>
      <div>{icon}</div>

      <div className={styles['item-title']}>
        {title}

        {description && description}
      </div>
    </div>
  );
};
